import { useTranslation } from 'react-i18next';
import { DynamicIcon, type IconName } from 'lucide-react/dynamic';
import { IconOption, IconPickerGrid, LatencyIcon } from './styles';
import DescriptionPopper from '@/components/DescriptionPopper';

const DEFAULT_OPTIONS: IconName[] = [
  'globe',
  'server',
  'cloud',
  'wifi',
  'router',
  'signal',
  'database',
  'link-2',
  'cpu',
  'hard-drive',
  'activity',
  'zap',
  'shield-check',
  'network',
  'gauge',
  'radio',
  'satellite',
  'monitor-check',
  'cable',
];

interface IconPickerProps {
  icon?: IconName;
  initials: string;
  editable?: boolean;
  iconOptions?: IconName[];
  onSelect: (icon?: IconName) => void;
}

function IconPicker({
  icon,
  initials,
  editable,
  iconOptions = DEFAULT_OPTIONS,
  onSelect,
}: IconPickerProps) {
  const { t } = useTranslation();

  const displayInitials = initials && initials.trim() ? initials : '?';

  return (
    <>
      <DescriptionPopper
        placement="right"
        children={
          <LatencyIcon>
            {icon ? <DynamicIcon name={icon} size={18} /> : displayInitials}
          </LatencyIcon>
        }
        description={
          editable ? (
            <IconPickerGrid>
              {/** Default Icon as initials */}
              <IconOption
                type="button"
                title={t('config.dashboard.notSelect')}
                $selected={!icon}
                onClick={() => onSelect(undefined)}
              >
                {displayInitials}
              </IconOption>
              {/** Icon Options */}
              {iconOptions.map((option) => (
                <IconOption
                  key={option}
                  type="button"
                  $selected={icon === option}
                  onClick={() => onSelect(option)}
                >
                  <DynamicIcon name={option} size={18} />
                </IconOption>
              ))}
            </IconPickerGrid>
          ) : null
        }
      />
    </>
  );
}

export default IconPicker;
